<template>
<section class="sm-account__main">
  <div class="sm-wrap sm">
    <div class="sm-account__main-inner">
      <account
        :userAccountProp="userAccount"
        @callMethod="callMethod"
      />
    </div>
  </div>
</section>
  
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'account-tabs',
  components: {
    'account': () => import('@/views/admin/pages/account/components/Account'),
  },
  data() {
    return {
      
    }
  },
  computed: {
    ...mapGetters({
      userAccount: 'account/userAccount',
      userPlan: 'account/userPlan'
    }),
   
  },
  methods: {
    ...mapActions({
      updateUser: 'account/updateUser',
      getActivity: 'account/getActivity',
      getAllNotarize: 'account/getAllNotarize'
    }),
    callMethod(method, callback, err, ...params) {
      if (!this[method])
        return false;

      this[method](...params)
        .then((res) => callback(res))
        .catch(e => err(e));
    }
  }
}
</script>

<style lang="scss">
  .sm-account__main {
    position: relative;
    
    &-inner {
      position: relative;
      margin: 34px 0 150px;

      & > .sm-tabs {
        margin-bottom: 30px;
      }
    }
  }
</style>
